module.exports = __webpack_public_path__ + "static/media/awards_7.7e69cbff.jpg";